export const EXPANSAO_ARVORE = {
  FECHADO: 0,
  PARCIALMENTE_ABERTO: 1,
  ABERTO: 2,
};

export function montarChavesExpansao(nos, expansao) {
  const lista = nos || [];

  if (Number(expansao) === EXPANSAO_ARVORE.ABERTO) {
    const chaves = [];
    const percorrer = nodes => {
      (nodes || []).forEach(no => {
        if (no?.key != null) chaves.push(String(no.key));
        percorrer(no.children);
      });
    };
    percorrer(lista);
    return chaves;
  }

  if (Number(expansao) === EXPANSAO_ARVORE.PARCIALMENTE_ABERTO) {
    const primeiro = lista[0];
    return primeiro?.key != null ? [String(primeiro.key)] : [];
  }

  return [];
}
